import md5 from "blueimp-md5";
import React from "react";

import { cn } from "@/lib/cn";

interface AvatarProps {
  className?: string;
  email?: string;
  title: string;
}
export const Avatar = (props: AvatarProps) => {
  const { className, email = "john.doe@example.com", title } = props;

  return (
    <img
      className={cn("block size-[68px] rounded-full border border-border", className)}
      title={title}
      src={`https://secure.gravatar.com/avatar/${md5(
        email.toLowerCase().trim(),
      )}?s=${120}&d=${encodeURIComponent("mm")}`}
      alt={`${title} avatar`}
    />
  );
};
